import { useTranslation } from 'react-i18next'
import { useFormikContext } from 'formik'

import { EMPTY_OBJECT } from '../../../../../constants/common'
import { useScreen } from '../../../../../hooks'
import { isStaffUser } from '../../../../../utils/user'
import {
  FlatSelect,
  getFlatSelectFormikFieldControlDisabledProps,
} from '../../../../Flat'
import { FormFieldSelectNG } from '../../../../Form'
import { FormikField, getFormikFormFieldErrorProps } from '../../../../Formik'
import {
  REQUEST_FORM_FIELD_NAME_APPLICANT,
  REQUEST_FORM_FIELD_NAME_BUILDING,
  REQUEST_FORM_FIELD_NAME_FLAT,
} from '../../RequestForm.constants'

import { getFlatApiParams } from './FlatField.utils'

function FlatField({ apiParams, requiredFields, ...restProps }) {
  const { t } = useTranslation()

  const { values } = useFormikContext()

  const { isMobileScreenSize } = useScreen() // TODO make same by css media instead of useScreen

  const flatApiParams = {
    ...apiParams,
    ...getFlatApiParams(
      values,
      isStaffUser(values[REQUEST_FORM_FIELD_NAME_APPLICANT] || EMPTY_OBJECT)
    ),
  }

  return (
    <FormikField
      {...restProps}
      Component={FormFieldSelectNG}
      Select={FlatSelect}
      apiParams={flatApiParams}
      controlProps={{
        borderless: !isMobileScreenSize,
        contentProps: {
          inputProps: {
            placeholder: t('Request.FlatPlaceholderKey'),
          },
        },
      }}
      disabled={!values[REQUEST_FORM_FIELD_NAME_BUILDING]}
      emptyValue={null}
      fieldComponentProps={{
        label: `${t('Request.FlatLabelKey')}:`,
        required: requiredFields.includes(REQUEST_FORM_FIELD_NAME_FLAT),
        shouldAdaptToMobileScreen: true,
      }}
      getErrorProps={getFormikFormFieldErrorProps}
      getFieldDisabledProps={getFlatSelectFormikFieldControlDisabledProps}
      name={REQUEST_FORM_FIELD_NAME_FLAT}
    />
  )
}

export default FlatField
